// extracted by mini-css-extract-plugin
module.exports = {"modalButton":"style__modalButton__Oup8k"};